module.exports = __webpack_public_path__ + "img/app-store-badge.ebdcadff.svg";